import { clampTrimRange } from "@memento/library/segment";

export enum EDIT_TYPE {
  TRIM = "trim",
  ROTATE = "rotate",
  TEXT = "text",
  SETTINGS = "settings",
}

export type Orientation = "landscape" | "portrait";

export type TrimRange = {
  min: number;
  max: number;
};

export function trimRangeToDurationRange(
  trimTimes: TrimRange,
  duration: number
) {
  return clampTrimRange({
    start: trimTimes.min / duration,
    end: trimTimes.max / duration,
  });
}
